import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './Button';
interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  className?: string;
}
export function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  className = ''
}: PaginationProps) {
  if (totalPages <= 1) return null;
  return <div className={`flex items-center justify-between px-4 py-3 bg-white border-t border-gray-200 sm:px-6 ${className}`} data-id="element-109">
      <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-110">
        <div data-id="element-111">
          <p className="text-sm text-gray-700" data-id="element-112">
            Showing page <span className="font-medium" data-id="element-113">{currentPage}</span> of{' '}
            <span className="font-medium" data-id="element-114">{totalPages}</span>
          </p>
        </div>
        <div data-id="element-115">
          <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-116">
            <Button variant="outline" size="sm" onClick={() => onPageChange(Math.max(1, currentPage - 1))} disabled={currentPage === 1} className="rounded-l-md rounded-r-none" data-id="element-117">
              <ChevronLeft className="h-4 w-4" data-id="element-118" />
              <span className="sr-only" data-id="element-119">Previous</span>
            </Button>

            {/* Simple page numbers - can be expanded for complex logic */}
            {Array.from({
            length: Math.min(5, totalPages)
          }, (_, i) => {
            // Logic to show window around current page
            let pageNum = i + 1;
            if (totalPages > 5) {
              if (currentPage > 3) {
                pageNum = currentPage - 2 + i;
              }
              if (pageNum > totalPages) {
                pageNum = totalPages - 4 + i;
              }
            }
            return <button key={pageNum} onClick={() => onPageChange(pageNum)} className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${currentPage === pageNum ? 'z-10 bg-green-50 border-[#1B6B3A] text-[#1B6B3A]' : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'}`} data-id="element-120">
                    {pageNum}
                  </button>;
          })}

            <Button variant="outline" size="sm" onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))} disabled={currentPage === totalPages} className="rounded-l-none rounded-r-md" data-id="element-121">
              <ChevronRight className="h-4 w-4" data-id="element-122" />
              <span className="sr-only" data-id="element-123">Next</span>
            </Button>
          </nav>
        </div>
      </div>

      {/* Mobile View */}
      <div className="flex items-center justify-between w-full sm:hidden" data-id="element-124">
        <Button variant="outline" size="sm" onClick={() => onPageChange(Math.max(1, currentPage - 1))} disabled={currentPage === 1} data-id="element-125">
          Previous
        </Button>
        <span className="text-sm text-gray-700" data-id="element-126">
          Page {currentPage} of {totalPages}
        </span>
        <Button variant="outline" size="sm" onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))} disabled={currentPage === totalPages} data-id="element-127">
          Next
        </Button>
      </div>
    </div>;
}